import React, {FC} from 'react';
import styled from 'styled-components';

/*
 * Constants.
 */

export const tabWrapperGap = 16;

/*
 * Props.
 */

interface TabsWrapperProps {
  className?: string;
}

/*
 * Style.
 */

const StyledTabsWrapperDiv = styled.div`
  flex: 1;
  display: flex;
  flex-flow: row;
  gap: 16px;
  padding-top: ${tabWrapperGap}px;
  overflow: hidden;
`;

/*
 * Component.
 */

export const TabsWrapper: FC<TabsWrapperProps> = ({children, className}) => (
  <StyledTabsWrapperDiv className={className}>{children}</StyledTabsWrapperDiv>
);
